import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-116c4744"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "h-screen w-screen flex flex-col overflow-hidden" };
const _hoisted_2 = {
    key: 0,
    class: "header-section"
};
const _hoisted_3 = {
    key: 1,
    class: "progress-header"
};
const _hoisted_4 = { class: "progress-container" };
const _hoisted_5 = ["disabled", "title"];
const _hoisted_6 = {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    style: { "margin-right": "8px" },
    class: "nav-icon"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", {
    d: "M15 18L9 12L15 6",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "nav-text" };
const _hoisted_10 = { class: "progress-track" };
const _hoisted_11 = { class: "step-indicators" };
const _hoisted_12 = ["title"];
const _hoisted_13 = {
    key: 0,
    class: "check-mark"
};
const _hoisted_14 = {
    key: 1,
    class: "step-number"
};
const _hoisted_15 = { class: "current-step-info" };
const _hoisted_16 = { class: "step-text" };
const _hoisted_17 = { class: "step-counter" };
const _hoisted_18 = ["disabled", "title"];
const _hoisted_19 = {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    style: { "margin-right": "8px" },
    class: "nav-icon"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", {
    d: "M9 18L15 12L9 6",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1));
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = { class: "nav-text" };
const _hoisted_23 = { class: "content-section" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { key: 1 };
const _hoisted_26 = { key: 2 };
const _hoisted_27 = { key: 3 };
const _hoisted_28 = { key: 4 };
const _hoisted_29 = { key: 5 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AdminUIHeader = _resolveComponent("AdminUIHeader");
    const _component_RegisterEmailForm = _resolveComponent("RegisterEmailForm");
    const _component_ContactInformation = _resolveComponent("ContactInformation");
    const _component_CompanyCheckForm = _resolveComponent("CompanyCheckForm");
    const _component_CompanyInformationsForm = _resolveComponent("CompanyInformationsForm");
    const _component_RightsForm = _resolveComponent("RightsForm");
    const _component_SummaryForm = _resolveComponent("SummaryForm");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
                (_ctx.nbrCurrentShowToForm !== 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_AdminUIHeader)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.nbrCurrentShowToForm !== 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (_ctx.canGoToPreviousStep())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: _normalizeClass(["nav-button nav-button-left", { disabled: _ctx.isCheckingVat }]),
                                    disabled: _ctx.isCheckingVat,
                                    title: _ctx.t('admin-ui.previous'),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.goToPreviousStep()))
                                }, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8)),
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('admin-ui.previous')), 1)
                                ], 10, _hoisted_5))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", {
                                    class: "progress-fill",
                                    style: _normalizeStyle({ width: _ctx.getProgressPercentage() + '%' })
                                }, null, 4)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: _normalizeClass({
                                            'step-dot': true,
                                            active: _ctx.isStepActive(step.number),
                                            completed: _ctx.isStepCompleted(step.number),
                                        }),
                                        title: _ctx.getStepTooltip(step)
                                    }, [
                                        (_ctx.isStepCompleted(step.number))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "✓"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(index + 1), 1))
                                    ], 10, _hoisted_12));
                                }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getCurrentStepTitle()), 1),
                                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getCurrentStepNumber()) + "/5", 1)
                            ]),
                            (_ctx.canGoToNextStep())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: _normalizeClass(["action-button", { disabled: _ctx.isCheckingVat }]),
                                    disabled: _ctx.isCheckingVat,
                                    title: _ctx.getNextActionTitle(),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.smartGoToNextStep()))
                                }, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21)),
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.getNextActionLabel()), 1)
                                ], 10, _hoisted_18))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                    (_ctx.nbrCurrentShowToForm === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createVNode(_component_RegisterEmailForm, {
                                "show-mobile-version": _ctx.showMobileVersion,
                                "show-banner": _ctx.showBanner,
                                "text-banner": _ctx.textBanner,
                                "show-animation-banner": _ctx.showAnimationBanner,
                                onSendMail: _ctx.sendUserEmail,
                                onClose: _ctx.closeBanner,
                                onLanguageChanged: _ctx.updateBannerTextForLanguage
                            }, null, 8, ["show-mobile-version", "show-banner", "text-banner", "show-animation-banner", "onSendMail", "onClose", "onLanguageChanged"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.nbrCurrentShowToForm === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_ContactInformation, {
                                "show-mobile-version": _ctx.showMobileVersion,
                                "show-banner": _ctx.showBanner,
                                "text-banner": _ctx.textBanner,
                                "show-animation-banner": _ctx.showAnimationBanner,
                                "error-fetch-api": _ctx.canGetCustomerEmail,
                                "user-retrieved-data": _ctx.userRetrievedData,
                                "user-data": _ctx.myUser,
                                "trigger-validation": _ctx.triggerContactValidation,
                                onNextClick: _ctx.checkContactForm,
                                onClose: _ctx.closeBanner,
                                onValidationResult: _ctx.handleContactValidationResult
                            }, null, 8, ["show-mobile-version", "show-banner", "text-banner", "show-animation-banner", "error-fetch-api", "user-retrieved-data", "user-data", "trigger-validation", "onNextClick", "onClose", "onValidationResult"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.nbrCurrentShowToForm === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_CompanyCheckForm, {
                                "nbr-of-request-api-made": _ctx.nbrRequestApiCheckVat,
                                "error-api": _ctx.hasVatErrorAPI,
                                "message-api": _ctx.messageVatAPI,
                                "is-checking-vat-api": _ctx.isCheckingVat,
                                "my-object": _ctx.myUser,
                                "trigger-validation": _ctx.triggerVatValidation,
                                "show-banner": _ctx.showBanner,
                                "text-banner": _ctx.textBanner,
                                "show-animation-banner": _ctx.showAnimationBanner,
                                onNextClick: _ctx.CheckVatForm,
                                onPreviousClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showForm(2))),
                                onClose: _ctx.closeBanner,
                                onValidationResult: _ctx.handleVatValidationResult
                            }, null, 8, ["nbr-of-request-api-made", "error-api", "message-api", "is-checking-vat-api", "my-object", "trigger-validation", "show-banner", "text-banner", "show-animation-banner", "onNextClick", "onClose", "onValidationResult"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.nbrCurrentShowToForm === 5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_CompanyInformationsForm, {
                                "my-object": _ctx.myUser,
                                "trigger-validation": _ctx.triggerCompanyValidation,
                                "show-banner": _ctx.showBanner,
                                "text-banner": _ctx.textBanner,
                                "show-animation-banner": _ctx.showAnimationBanner,
                                onNextClick: _ctx.checkCompanyInformationsForm,
                                onPreviousClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showForm(4))),
                                onClose: _ctx.closeBanner,
                                onValidationResult: _ctx.handleCompanyValidationResult
                            }, null, 8, ["my-object", "trigger-validation", "show-banner", "text-banner", "show-animation-banner", "onNextClick", "onClose", "onValidationResult"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.nbrCurrentShowToForm === 6)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_RightsForm, {
                                "my-object": _ctx.myUser,
                                "trigger-validation": _ctx.triggerRightsValidation,
                                "show-banner": _ctx.showBanner,
                                "text-banner": _ctx.textBanner,
                                "show-animation-banner": _ctx.showAnimationBanner,
                                onNextClick: _ctx.checkRightsForm,
                                onPreviousClick: _cache[4] || (_cache[4] = ($event) => (_ctx.showForm(5))),
                                onClose: _ctx.closeBanner,
                                onValidationResult: _ctx.handleRightsValidationResult
                            }, null, 8, ["my-object", "trigger-validation", "show-banner", "text-banner", "show-animation-banner", "onNextClick", "onClose", "onValidationResult"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.nbrCurrentShowToForm === 7)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_SummaryForm, {
                                "my-object": _ctx.myUser,
                                onPreviousClick: _cache[5] || (_cache[5] = ($event) => (_ctx.showForm(6)))
                            }, null, 8, ["my-object"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
